import styled from "styled-components";

import Typography from "../../typography/Typography/Typography";
import { StyledLabelProps } from "./Label.types";

const StyledLabel = styled(Typography)<StyledLabelProps>`
	${(props) =>
		props.required
			? `:before {
            content: "*";
            color: ${props.theme.palette.hexFor("semantic_error_600")};
            margin-right: ${props.theme.space.xxs};
        }`
			: ""}
`;

export default StyledLabel;
